import UserService from "../../services/UserService";
import {useEffect } from 'react';

const Login = () => {
    useEffect (()=> {UserService.doLogin()},[])
    return (<></>)
};
export default Login;